// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class GetWorkflowsRequestModel {
    static getAttributeTypeMap() {
        return GetWorkflowsRequestModel.attributeTypeMap;
    }
}
GetWorkflowsRequestModel.discriminator = undefined;
GetWorkflowsRequestModel.attributeTypeMap = [
    {
        "name": "accountId",
        "baseName": "accountId",
        "type": "number"
    },
    {
        "name": "includePayors",
        "baseName": "includePayors",
        "type": "boolean"
    },
    {
        "name": "includePharmacies",
        "baseName": "includePharmacies",
        "type": "boolean"
    },
    {
        "name": "includePrescribers",
        "baseName": "includePrescribers",
        "type": "boolean"
    }
];
//# sourceMappingURL=getWorkflowsRequestModel.js.map